<div>
  <button (click)="scrollToTop()" [@scrollButton]="animationState" class="scroll-top-button"><span><i class="fas fa-chevron-up"></i></span><br />Top</button>
</div>
